import Api from '@/services/Api'

export default {
	send(data) {
		return Api().post('/instances/new', data)
	}
}
